<template>
  <div class="search-geometic-page">
    <div v-if="pagetype==='upload'" style="height: 100%;">
        <div class="header-box">
            <div style="width: 50%;">
                <div v-if="status==='noupload'">上传模型</div>
                <div class="progress-box" v-if="status ==='uploading' && uploadPercentage < 100">
                    <div style="margin-right:12px">上传中</div>
                    <el-progress :percentage="uploadPercentage" :stroke-width="16"></el-progress>
                </div>
                <div v-if="uploadPercentage == 100 && status !=='error'&& status !=='noupload'">
                    <i class="el-icon-success" style="color:#52C41A;"></i>
                    上传成功
                    <el-button v-if="status ==='uploading'"  class="btn" type="primary"  size="small" style="margin-left: 20px;" >解析中...</el-button>
                    <el-button v-if="status ==='uploaded'"  class="btn" type="primary" size="small" style="margin-left: 20px;" @click="triggerUpload">更换模型</el-button>

                    <!-- <el-button v-if="status ==='uploaded'"  class="btn" type="primary" size="small" style="margin-left: 20px;" @click="handleType('search')">智能搜索</el-button> -->
                </div>
                <div v-if="status ==='error'">
                    <i class="el-icon-error" style="color:#E84335;"></i>
                    上传失败
                </div>
            </div>
            <div style="margin-left: 20px;">企业解决方案</div>
        </div>
        <div class="content">
            <div style="position: relative;margin-right: 20px;" class="card upload-area">
                <div>
                    <div class="mask" v-if="status === 'uploading'"></div>
                    <Upload
                        ref="uploadRef"
                        class="upload-box"
                        drag
                        action="https://api60.global-dsc.cn/file/geometry"
                        :multiple="false"
                        name="file"
                        accept=".sldprt,.step"
                        :show-file-list="false"
                        :file-list="fileList"
                        :on-success="handleSuccess"
                        :on-progress="handleProgress"
                        :on-error="handleError"
                        :before-upload="handleUpload"
                        :headers="token"
                    >
                        <div v-show="status!=='uploaded'" class="upload-click-btn">
                            <div>
                                <i class="el-icon-upload" v-if="status!=='uploading'"></i>
                                <i class="el-icon-loading" v-if="status==='uploading'" style="font-size: 50px;margin-top: 40px;"></i>
                                
                                <div class="el-upload__text" v-if="status==='uploading' && uploadPercentage == 100"><em>模型解析中...</em></div>
                                <div class="el-upload__text" v-if="status==='noupload'"><em>点击上传</em></div>
                                <div class="el-upload__text" v-if="status==='error'"><em>重新上传</em></div>
                                <div class="el-upload__tip" slot="tip">*支持solidworks（2023及以下）、step格式</div>
                            </div>
                        </div>

                        <div v-if="status==='uploaded'">
                            <div   style="width: 200px;height: 200px;position: relative; left:50px;">
                                <iframe frameborder="0" width="100%" height="100%"  :src="uploadData.viewUrl" v-if="uploadData.viewUrl"></iframe>
                                <img src="/resource/images/icon2.png" alt="" width="100px" style="margin-top: 50px;" v-if="!uploadData.viewUrl">
                            </div>
                            <div class="el-uploaded__text" v-if="status==='uploaded'"> <i class="el-icon-upload2" style="margin-right: 6px;font-size: 20px;"></i><em>重新上传</em></div>
                        </div>
                    </Upload>
                </div>
                <div class="file-name">{{fileName }}</div>
                <div style="margin-top: 20px;">
                    <el-button v-if="status ==='uploaded'"  class="btn" type="primary"  size="small" style="width: 100px;"  @click="handleType('search')">搜索</el-button>
                    <el-button  v-if="status !=='uploaded'" type="info" size="small" style="width: 100px;" >搜索</el-button>
                </div>
            </div>
            <div class="card">
                <div>
                    <div class="sousuo-title">企业缩减成本的利器 — 模型智能检索</div>
                    <div class="desc">提高企业零部件重复性使用率，快速查找相似模型，实现快速模型借鉴使用，提升工程师设计效率。</div>
                    <div class="desc">企业库应用：</div>
                </div>
                <div>
                <img src="https://prodimg.global-dsc.cn/e6b749657541b4e214f12bcc12d56035.jpg" alt="" style="width: 49%; margin-right: 2%;" />
                <img src="https://prodimg.global-dsc.cn/8baefd280ed8860499130ad012ad991d111.jpg" alt=""  style="width: 49%;" />
                </div>
                
            </div>
        </div>
    </div>
    <!-- 搜索数据 -->
     <div v-if="pagetype==='search'">
        <div class="header-box">
            <div>
                <span>找到{{list.length}}个和“{{fileName}}”相似的结果</span>
                <el-button class="btn" type="primary" size="small" style="margin-left: 20px;" @click="handleType('upload')">重新选择模型</el-button>
            </div>
        </div>
        <div class="pro-box" >
            <div class="pro-list-block" v-for="item,idx in list" :key="idx">
                <pro-card :data="item"></pro-card>
              
            </div>
            <div class="list-card-empty" v-for="item of 20" :key="`key_${item}`"></div>
             <el-empty description="没搜索到类似的结果~" v-if="list.length < 1"></el-empty>
        </div>
     </div>
  </div>
</template>

<script>
import {AdvertsType, AdvertsService, UtilLibs, CheckLibs,UserService} from '@digital-supply-chain/module'

import { TodaySearchService, Message } from "@/service";
import {Upload} from 'element-ui'
import ProCard from './components/pro-card.vue';
export default {
  components: {Upload, ProCard},
  data() {
    return {
    pagetype: 'upload',
        uploadPercentage: 0,
        status: 'noupload',
        fileList: [],
        fileName: '',
        token: {},
        list: [],
        uploadData: {},
    };
  },
  computed: {
   
  },
   mounted() {
     let token = UserService.token(true);
    this.token = {Authorization: token};
  },
  methods: {

     // 触发上传
    triggerUpload() {
      this.$refs.uploadRef.$el.querySelector('input[type="file"]').click();
    },

    async modelList() {
        const {modelId} = this.uploadData
        const res = await TodaySearchService.modelList(modelId);
        if(res.code === 0) {
            res.data.forEach((item)=> {
                item.modelSimiarity = Math.round((item.modelSimiarity * 100))
            })
        }
        this.list = res.data;
    },
    handleProgress(event, file, fileList) {
        const precent = Math.round((event.loaded / event.total) * 100);
        this.status = 'uploading';
        let progresstimeval = setInterval(()=> {
            if(this.uploadPercentage === 100) {
                clearInterval(progresstimeval);
                progresstimeval = null;
            }else {
                if(precent === 100 && this.uploadPercentage === 99) {
                    this.uploadPercentage = precent;
                }else {
                    this.uploadPercentage = this.uploadPercentage + 1;
                }
            }
        },100)
        
    },
    handleUpload(file) {
         // 文件大小限制：10MB
        const isLt10M = file.size / 1024 / 1024 <= 10;
        
        if (!isLt10M) {
           Message.error('上传文件大小不能超过 10MB!');
            return false; // 阻止上传
        }
        return true; // 返回 true 继续上传
    },
    handleError(err) {
        Message.error('上传失败，请重新上传')
        this.status = 'error';
        this.uploadPercentage = 0;
    },
    handleSuccess(response, file, fileList) {
        if(response.State === 0) {
            Message.error(response.Error.Message);
            this.status = 'error';
            this.uploadPercentage = 0;
            return
        }
        const data = response.Data;
       this.modelUploadStatus(data, file);
    },
    handleType(type) {
        this.pagetype = type;
        if(type === 'search') {
            this.modelList()
        }
    },
    // 判断是否上传解析成功
    modelUploadStatus(data, file) {
        let timeval = setInterval(async()=> {
            const res = await TodaySearchService.modelUploadStatus(data.modelId);
            if(res.code == 200) {
                clearInterval(timeval);
                timeval = null;
                this.status = 'uploaded';
                this.uploadData = data;
                this.fileName = file.name;
                this.fileList = [file];
            }else if(res.code == 504) {
                Message.error(res.data);
                clearInterval(timeval);
                timeval = null;
                this.status = 'error';
                this.uploadPercentage = 0;
            }
        },500)
    }
  },
 
};
</script>

<style lang="less" scoped>
.search-geometic-page {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
//   padding: 16px 0;
  overflow-x: hidden;
  
}
.header-box {
    height: 40px;
    display: flex;
    align-items: center;
    padding: 5px;
    border-bottom: 1px solid #D6D6D6;
}
.progress-box {
    width: 400px;
    display: flex;
    align-items: center;
}
.progress-box ::v-deep .el-progress {
    display: flex;
    flex: 1;
}
.content {
    display: flex;
    // align-items: center;
    justify-content: center;
    height: calc(100% - 40px);
    margin-top: 20px;

    .mask {
        width: 100%;
        height: 100%;
        position: absolute;
        left:0;right: 0;
        bottom: 0;
        z-index: 10;
    }
}
.upload-area {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
.card {
    width: 49%;
    height: 600px;
    border-radius: 8px;
    background: #fff;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
    padding: 10px;
}
.sousuo-title {
    color: #000;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
}
.desc {
    line-height: 28px;
    margin-bottom: 10px;
}
.file-name {
    // color:#124B92;
    margin-top: 20px;
}
.upload-box {
    width: 300px;
    height: 300px;
    .upload-click-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }
    ::v-deep .el-upload-dragger {
        width: 300px;
        height: 300px;
        border-radius: 12px;
        box-sizing: border-box;
        border: 2px dashed #124B92;
    }
    ::v-deep .el-upload-dragger .el-icon-upload {
        margin: 0;
    }
    ::v-deep .el-upload-dragger .el-uploaded__text {
        margin-top: 30px;
        color: #124B92;
        font-size: 18px;
        
        em {
            font-style:normal;
        }
    }
    ::v-deep .el-upload-dragger .el-upload__text em {
        color: #124B92;
        font-size: 18px;
        font-style:normal;
    }
     ::v-deep .el-upload-dragger iframe {
        opacity: 1;
        z-index: 300;
     }
    ::v-deep .el-upload__tip {
        margin-top: 10px;
        color: #124B92;
    }
}
.btn::v-deep.el-button--primary {
    background: #124B92;
    border-color: #124B92;
    letter-spacing: 1px;
}

.pro-box {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding-top: 20px;

    .pro-list-block {
        min-width: 150px;
        max-width: 180px;
        margin: 0 5px 10px 5px;
        flex: 1;
        border: 1px solid #d6d6d6;
        position: relative;
        &>.list-card{
            margin: 0;
            position: initial;
            height: 100%;
            border: 0 none;
            min-width: 100%;
        }
    }
  
    .list-card-empty {
        font-size: 0;
        min-width: 150px;
        max-width: 180px;
        margin: 0 5px 10px 5px;
        flex: 1;
        border: 1px solid transparent;
    }
}
</style>